import React from 'react';
import {startQuiz, submitAnswer, previewQuiz, progressQuiz} from '../../api';
import {Check, ChevronLeft, ChevronRight, Save as SubmitIcon} from '@material-ui/icons';
import {isEmpty} from 'lodash/lang';
import {
    Button,
    ButtonGroup,
    FormControlLabel,
    Checkbox,
    FormGroup,
    RadioGroup,
    Radio,
    SnackbarContent
} from '@material-ui/core';
import {withRouter} from 'react-router-dom';
import queryString from 'query-string';
import {addFlashMessage} from '../../actions/flash-message';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import QuizTakeStart from './QuizTakeStart';
import {buildQueryString, decodeURIJSON, formatQuizAnswersForBackend, formatStudentAnswerForBackend, buildAnswers} from '../../utils/common';
import QuizTakeNav from './QuizTakeNav';
import SnackbarContentWrapper from '../common/SnackbarContentWrapper';
import Modal from '../common/Modal';
import classnames from 'classnames';
import {shuffle} from 'lodash/collection';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {QuizStartMessage} from './QuizStartMessage';
import {instanceQuiz, postInstance} from '../../api'; 



class QuizTake extends React.Component {

    constructor(props) {
        super(props);
        const {match: {params: {quizId}}, location} = props;

        this.quizId = quizId;
        this.state = {
            quizDataDict: {},
            currentIndex: null,
            singlePage: true, // Will be determined from the quiz config when available.
            answers: {},
            userURLParams: queryString.parse(location.search),
            showReview: false,
            showConfirmSubmitModal: false,
            shuffled: false,
            showStartScreen: true,
            language: location?.state?.language || 'en'
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.submitStartQuizForm = this.submitStartQuizForm.bind(this);
        this.randomizeQuestions = this.randomizeQuestions.bind(this);
        this.randomizeAnswers = this.randomizeAnswers.bind(this);
        this.hideStartScreen = this.hideStartScreen.bind(this);
        this.receiveLanguageHandler = this.receiveLanguageHandler.bind(this);
    }

    submitStartQuizForm(userData) {
        const {history} = this.props;
        window.parent.postMessage({
            message: 'user-details',
            userData: userData
        }, '*');
        this.setState({userURLParams: userData}, ()=> {
            this.startQuizAction(userData).then(() =>
                history.push(`/quizzes/${this.quizId}/take?${buildQueryString(userData)}`));
        });
    }

    /**
     * Randomize questions once, and once only per-quiz take
     *
    */
    randomizeQuestions(){
        const {quizDataDict, shuffled} = this.state;
        let workingDataDict = quizDataDict;

        if (!shuffled) {
            if (workingDataDict.questions) {
                let qsWithShuffledAnswers = this.randomizeAnswers(workingDataDict.questions);
                if (workingDataDict.options.randomizeQuestions) {
                    workingDataDict.questions = shuffle(qsWithShuffledAnswers);
                    this.setState({
                        quizDataDict: workingDataDict,
                    });
                }
                this.setState({shuffled: true});
            }
        }
        return workingDataDict;
    }

    randomizeAnswers(questions) {
        let shuffledQuestions = questions;
        for (let currentQuestion of shuffledQuestions){
            currentQuestion.answers = currentQuestion.randomize_answers ?
                shuffle(currentQuestion.answers) : currentQuestion.answers;
        }
        return shuffledQuestions;
    }


    questionList() {
        const {currentIndex, showReview = false, singlePage} = this.state;
        let questions = [];
        let workingDataDict = this.randomizeQuestions();

        if (showReview || !singlePage) {
            // if (quizDataDict.settings && quizDataDict.settings.singlePage) {
            questions = workingDataDict.questions;
        } else {
            questions = workingDataDict.questions.length > 0 ? [workingDataDict.questions[currentIndex]] : [];
        }
        return questions;
    }

    handleSubmit() {
        const {answers, quizDataDict} = this.state;
        const {addFlashMessage, match: {params: {actionType}}} = this.props;
        const {router} = this.context;
        let resolvePromise;
        if (actionType === 'preview') {
            resolvePromise = Promise.resolve(addFlashMessage('Quiz successfully submitted.', 'success'));
        } else {
            resolvePromise = submitAnswer(this.quizId, quizDataDict._id.$oid,
                formatQuizAnswersForBackend(answers)).then((response) => {
                router.history.push({
                    pathname: `/quizzes/${response._id.$oid}/answers`,
                    state: {data: response},
                });
                addFlashMessage('Quiz successfully submitted.', 'success');
                sessionStorage.removeItem('currentIndex')
                postInstance(this.quizId, 0, quizDataDict._id.$oid)
            }).catch(() =>
                addFlashMessage('Failed submitting the answer.', 'error')
            );  
        }
        resolvePromise.finally(() => {
            this.setState({showConfirmSubmitModal: false});
            window.parent.postMessage('submit', '*')
        });
    }

    isStartQuizUserInfoProvided() {
        const {userURLParams = {}} = this.state;
        return (!isEmpty(userURLParams.user_name) &&
            !isEmpty(userURLParams.platform_user_id) &&
            !isEmpty(userURLParams.email)) || 
            !isEmpty(userURLParams.jwt);
    }

    startQuizAction = (queryParams) =>
        startQuiz(this.quizId, queryParams).then(data => {
            this.setState({
                quizDataDict: data,
                answers: buildAnswers(data.questions),
                singlePage: data.options.singleQuestionPages != null ? data.options.singleQuestionPages : true,
            });
        }).catch(() =>
            addFlashMessage('An error occurred retrieving the quiz.', 'error')
        );

    componentDidMount() {
        const {userURLParams} = this.state;
        const {match: {params: {actionType}}} = this.props;

        if (this.quizId) {
            if (actionType === 'preview') {
                previewQuiz(this.quizId).then(data => {
                    const quiz = data.quiz;
                    this.setState({
                        quizDataDict: quiz,
                        singlePage: quiz.options.singleQuestionPages != null ? quiz.options.singleQuestionPages : true,
                    });
                });
            } else {
                if (this.isStartQuizUserInfoProvided()) {
                    for (let [key, value] of Object.entries(userURLParams)) {
                        userURLParams[key] = unescape(value);
                    }
                    this.startQuizAction(userURLParams);
                }
            }
        }
        window.addEventListener('message', this.receiveLanguageHandler, false);
    }
    receiveLanguageHandler(e) {
        if(e.data.message === 'language'){
            this.setState({
                language: e.data.language
            });
        }
    }

    handleChange(e, question) {
        const {answers, quizDataDict} = this.state;
        if (question._cls === 'SingleChoiceUserQuizQuestion') {
            // Single answer but treat as array for consistency with multiple choice answer.
            answers[question._id.$oid] = [e.target.value];
           progressQuiz(this.quizId, quizDataDict._id.$oid, formatStudentAnswerForBackend(answers))
        } else if (question._cls === 'MultipleChoiceUserQuizQuestion') {
            const answerId = e.target.value;
            if (e.target.checked) {
                if (answers[question._id.$oid]) {
                    answers[question._id.$oid].push(answerId);
                    progressQuiz(this.quizId, quizDataDict._id.$oid, formatStudentAnswerForBackend(answers))
                } else {
                    answers[question._id.$oid] = [answerId];
                }
            } else {
                // Unchecked - remove answer.
                if (answers[question._id.$oid]) {
                    const index = answers[question._id.$oid].findIndex(
                        currentAnswerId => currentAnswerId === answerId);
                    if (index !== -1) {
                        answers[question._id.$oid].splice(index, 1);
                    }
                }
            }
        } else {
            throw Error('Unhandled quiz type');
        }
        this.setState({answers});
    }

    hideStartScreen(){
        this.setState({
            showStartScreen: false
        });
        window.parent.postMessage('start-quiz', '*');
    }

    render() {
        const {quizDataDict, answers = {}, userURLParams = {}, showReview = false,
            showConfirmSubmitModal = false, currentIndex, singlePage, showStartScreen, language} = this.state;
        const {match: {params: {actionType}}, history} = this.props;

        if (!this.isStartQuizUserInfoProvided() && actionType !== 'preview') {
            return (

                <QuizTakeStart
                    onSubmit={this.submitStartQuizForm}
                    initialValues={decodeURIJSON(userURLParams)}
                />
                
            );
        }

        if (isEmpty(quizDataDict)) {
            return null;
        }

        const noQuestions = quizDataDict.questions.length < 1;

        const topRef = React.createRef();

        return (
            this.questionList().length ===  0 ? <div> Loading... </div> : 
                (<div className="quiz-container">
                    <Modal
                        title="Quiz Submission"
                        onClose={() => this.setState({showConfirmSubmitModal: false})}
                        open={showConfirmSubmitModal}
                        onConfirm={this.handleSubmit}
                        confirmButtonText={language === 'fr'? 'D\'accord' : null}
                        cancelButtonText={language === 'fr'? 'Annuler' : null}
                    >
                        {
                            language === 'fr' ? 'Voulez-vous vraiment soumettre ce quiz?' : 'Are you sure you want to submit this quiz?'
                        }
                    </Modal>
                    <div className={actionType === 'preview' ? 'quiz-container-content' : 'quiz-container-content-start'}>
                        {showStartScreen ?
                            QuizStartMessage(quizDataDict, answers, userURLParams, this.hideStartScreen, this.quizId, history, language) 
                            :
                        <>
                            {actionType === 'preview' && <p>
                                <Link to={`/quizzes/${quizDataDict._id.$oid}/edit`}>Quizzes</Link> > Quiz Preview</p>}
                            <h1 className="section-title" ref={topRef}>Quiz - {quizDataDict.name}</h1>
                        {noQuestions ?
                            <Typography>
                            There's no quiz questions available.
                            </Typography> :
                            <Typography variant="h6" className="text-align-right" color="secondary">
                            Total questions: {quizDataDict.questions.length}
                            </Typography>}
                            <div className="quiz-questions-list question-container">
                                {currentIndex !== null && this.questionList().map((question, quizQuestionIndex) => (
                                    <div key={quizQuestionIndex} className={classnames('quiz-questions-list-item', {
                                        quizQuestionsListItemError: showReview && isEmpty(answers[question._id.$oid]),
                                        outlined: !showReview || !isEmpty(answers[question._id.$oid]),
                                    })}>
                                        <Typography variant="subtitle2">
                                            <Box fontWeight="fontWeightBold">
                                                Question #{singlePage && !showReview ? currentIndex + 1 : quizQuestionIndex + 1}
                                            </Box>
                                        </Typography>
                                        <div dangerouslySetInnerHTML={{__html: question.content}}/>
                                        <form>
                                            <ul className="ul-take-quiz">
                                                {question._cls === 'SingleChoiceUserQuizQuestion' ? (
                                                    <RadioGroup
                                                        name={`radio-group-${quizQuestionIndex}`}
                                                        onChange={(e) => this.handleChange(e, question)}
                                                        value={answers[question._id.$oid] && answers[question._id.$oid].length > 0 ?
                                                            answers[question._id.$oid][0] : ''}
                                                    >
                                                        {question.answers.map((answer, questionAnswerIndex) => (
                                                            <li key={`quiz-question-${questionAnswerIndex}`} onClick={() =>
                                                                this.handleChange({target: {value: answer._id.$oid, checked: true}}, question)
                                                            }>
                                                                <FormControlLabel
                                                                    value={answer._id.$oid}
                                                                    control={<Radio/>}
                                                                />
                                                                {/*answer.correct && <Check className="quiz-check-green"/> */}
                                                                <div className="quiz-question-content"
                                                                    dangerouslySetInnerHTML={{__html: answer.content}}
                                                                />
                                                            </li>
                                                        ))}
                                                    </RadioGroup>
                                                ) : (
                                                    <FormGroup>
                                                        {question.answers.map((answer, questionAnswerIndex) => (
                                                            <li key={`quiz-question-${questionAnswerIndex}`}
                                                                onClick={() =>
                                                                    this.handleChange({
                                                                        target: {
                                                                            value: answer._id.$oid,
                                                                            checked: !answers[question._id.$oid].includes(answer._id.$oid)
                                                                        }
                                                                    }, question)}
                                                            >
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            onChange={e => this.handleChange(e, question)}
                                                                            value={answer._id.$oid}
                                                                            checked={answers[question._id.$oid] ?
                                                                                answers[question._id.$oid].includes(answer._id.$oid) :
                                                                                false}
                                                                        />
                                                                    }
                                                                />
                                                                {/*answer.correct && <Check className="quiz-check-green"/>*/}
                                                                <div className="quiz-question-content"
                                                                    dangerouslySetInnerHTML={{__html: answer.content}}/>
                                                            </li>
                                                        ))}
                                                    </FormGroup>
                                                )}

                                            </ul>
                                            {showReview && isEmpty(answers[question._id.$oid]) &&
                                            <SnackbarContentWrapper
                                                message={language === 'fr'? 'Vous n\'avez pas répondu à cette question.' : 'You haven\'t answered this question.'}
                                                variant="error"
                                            />}
                                        </form>
                                    </div>
                                ))}
                            </div>
                        </>
                    }
                </div>
                {!showStartScreen && <QuizTakeNav
                    changeCurrentIndex={index => this.setState({currentIndex: index})}
                    showReviewPage={showReview => this.setState({showReview})}
                    questions={quizDataDict.questions}
                    handleSubmit={() => this.setState({showConfirmSubmitModal: true})}
                    singlePage={singlePage}
                    preview={actionType === 'preview'}
                    topRef={topRef}
                    quizId = {this.quizId}
                    userQuizId = {quizDataDict._id.$oid}
                    language = {language}
                />}
            </div>)
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

QuizTake.contextTypes = {
    router: PropTypes.object.isRequired
};

export default withRouter(connect(
    null,
    mapDispatchToProps
)(QuizTake));
